import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { HoardingShowcase } from '../components/HoardingShowcase';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { PortfolioGallery } from '../components/PortfolioGallery';
import { Clients } from '../components/Clients';
import { EventManagement } from '../components/EventManagement';
import { ContactForm } from '../components/ContactForm';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Advertising Agency in Solapur | In Smart Media</title>
        <meta name="description" content="In Smart Media is an advertising agency in Solapur offering hoarding, E-rickshaw branding, outdoor advertising, digital marketing, print, radio and TV campaigns." />
        <meta name="keywords" content="advertising agency Solapur, hoarding advertising Solapur, E-rickshaw branding Solapur, digital marketing agency Solapur, outdoor advertising Solapur" />
        <link rel="canonical" href="https://www.insmartmedia.com/" />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <HoardingShowcase />
        <About />
        <PortfolioGallery />
        <Services />
        <WhyChooseUs />
        <Clients />
        <EventManagement />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
};

export default Home;
